var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6634 6.87191V14.9957C16.6634 17.4954 15.172 18.3286 13.3306 18.3286H6.66488C4.82348 18.3286 3.33203 17.4954 3.33203 14.9957V6.87191C3.33203 4.16397 4.82348 3.53906 6.66488 3.53906C6.66488 4.05565 6.87316 4.52225 7.21477 4.86387C7.55639 5.20548 8.02301 5.41379 8.5396 5.41379H11.4558C12.489 5.41379 13.3306 4.57224 13.3306 3.53906C15.172 3.53906 16.6634 4.16397 16.6634 6.87191Z",
    stroke: "#344054",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3298 3.53879C13.3298 4.57197 12.4882 5.41351 11.455 5.41351H8.53879C8.0222 5.41351 7.55558 5.20521 7.21396 4.86359C6.87234 4.52197 6.66406 4.05538 6.66406 3.53879C6.66406 2.50561 7.50561 1.66406 8.53879 1.66406H11.455C11.9716 1.66406 12.4382 1.87237 12.7799 2.21398C13.1215 2.5556 13.3298 3.0222 13.3298 3.53879Z",
    stroke: "#344054",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66406 10.8281H9.99691",
    stroke: "#344054",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66406 14.1641H13.3298",
    stroke: "#344054",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.aec3e9327faf5940cd0ff68c06726713.svg";
export { ForwardRef as ReactComponent };